import * as React from "react";
import * as _ from "lodash";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import { MenuItem } from "@bizform/primereact/components/menuitem/MenuItem";
import { AccordionMenuSub } from "./AccordionMenuSub";
import { ItemInformation, ITEMKEY } from "../BfAccordionMenu";

type Props = {
    id?: string;
    model?: MenuItem[];
    style?: object;
    className?: string;
    setActiveItem: (item: string, itemInfo: ItemInformation) => void;
    containsItems: (item: string) => boolean;
    selectedItem: (item: string) => boolean;
};

type State = {
    id?: string;
    model?: MenuItem[];
    style?: object;
    className?: string;
};

/**
 * Accordion Menu component element
 *
 * @since 0.0.1
 * @author Jongkwang Park
 * @class
 */
export class AccordionMenu extends React.Component {

    props: Props;
    state: State;

    static defaultProps = {
        id: null,
        model: null,
        style: null,
        className: null
    };

    private _toSetActiveItemAfterReset: MenuItem;

    constructor(props) {
        super(props);

        this._toSetActiveItemAfterReset = null;
        this.state = {};
    }

    onItemClick(event, item) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }

        if (!item.url) {
            event.preventDefault();
        }

        if (item.command) {
            item.command({
                originalEvent: event,
                item: item
            });
        }

        /*
        const itemInfo: ItemInformation = {
            hasItemValue: typeof item.itemValue !== "undefined",
            hasItems: typeof item.items !== "undefined"
        };
        */
        const itemInfo: ItemInformation = {
            // hasItemValue: item && _.trim(_.defaultTo(item.itemValue, "")) !== "",
            hasItemValue: typeof item.itemValue !== "undefined",
            hasItems: item && _.isArray(item.items) && item.items.length > 0
        };
        this.props.setActiveItem(item[ITEMKEY], itemInfo);
    }

    renderPanelIcon(item) {
        if (item.items) {
            const className = classNames("p-menuitem-icon", item.icon);
            return (
                <span className={className}></span>
            );
        } else if (item.icon) {
            return (
                <span className={item.icon}></span>
            );
        }
    }

    renderPanelToggleIcon(item, active) {
        const className = classNames("p-panelmenu-icon pi pi-fw", { "pi-caret-right": !active, " pi-caret-down": active });

        if (item.items) {
            return (
                <span className={className}></span>
            );
        } else {
            return null;
        }
    }

    renderPanel(item, index) {
        const active = this.props.containsItems(item[ITEMKEY]);
        const selectedItem = this.props.selectedItem(item[ITEMKEY]);
        const className = classNames("p-panelmenu-panel", item.className, {"p-disabled": item.disabled});
        const headerClassName = classNames("p-component p-panelmenu-header", {"p-highlight": active});
        const toggleIcon = this.renderPanelToggleIcon(item, active);
        const itemIcon = this.renderPanelIcon(item);
        const contentWrapperClassName = classNames("p-toggleable-content", {"p-toggleable-content-collapsed": !active});
        const itemClassName = classNames("p-panelmenu-header-link ng-tns-c2-1 ng-star-inserted", {"bf-menu-on": selectedItem});

        /* removed href={item.url || ""} in anchor tag, 2019.03.19 by k2webma */
        return (
            <div key={item.label + "_" + index} className={className} style={item.style}>
                <div className={headerClassName} style={item.style}>
                    <a className={itemClassName}
                       style={{cursor: "pointer"}}
                       onClick={(e) => this.onItemClick(e, item)}>
                        {toggleIcon}
                        {itemIcon}
                        <span className="p-menuitem-text">{item.label}</span>
                    </a>
                </div>
                <CSSTransition classNames="p-toggleable-content" timeout={{enter: 400, exit: 250}} in={active}>
                    <div className={contentWrapperClassName}>
                        <div className="p-panelmenu-content">
                            <AccordionMenuSub
                                model={item.items}
                                className="p-panelmenu-root-submenu"
                                setActiveItem={this.props.setActiveItem}
                                containsItems={this.props.containsItems}
                                selectedItem={this.props.selectedItem}
                            />
                        </div>
                    </div>
                </CSSTransition>
            </div>
        );
    }

    renderPanels() {
        if (this.props.model) {
            return (
                this.props.model.map((item, index) => {
                    return this.renderPanel(item, index);
                })
            );
        }
        else {
            return null;
        }
    }

    render() {
        const className = classNames("p-panelmenu p-component", this.props.className);
        const panels = this.renderPanels();

        return(
            <div id={this.props.id} className={className} style={this.props.style}>
                {panels}
            </div>
        );
    }
}
